export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/init',
    name: 'autologin',
    component: () => import('@/views/auth/AutoLogin.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
]
